import type { Move } from '../../../schemas/move';

/**
 * Mosse avanzate del Guerriero L6-10 (manuale V1, rr. 3578-3667).
 *
 * 14 mosse totali.
 *
 * Catene presenti:
 *  - *Fabbro*: anyOf [Arma Prescelta, warlock.vincolo-della-lama] (cross-class)
 *  - *Parata e Affondo*: richiede Parata
 *  - *La Salvezza nell'Acciaio*: richiede Parata
 *  - *Combattente Opportunistico*: richiede Tecniche Segrete di Combattimento
 *  - *Spietato*: richiede L'Odore del Sangue
 *  - *Mercenario di Lungo Corso*: richiede Veterano
 *  - *Malocchio*: richiede Vedere Rosso
 *  - *Perfezione in Armatura*: SOSTITUISCE Maestria in Armatura
 */

const fabbro: Move = {
  id: 'guerriero.fabbro',
  name: 'Fabbro',
  type: 'advanced_6_10',
  classId: 'guerriero',
  trigger: 'Quando hai accesso a una forgia',
  description:
    "Puoi distruggere un'arma e trasferire le sue proprietà magiche alla Tua Arma.\n\nInoltre, se hai la mossa *Cimelio*, quando hai accesso a una forgia e hai a disposizione un'arma adeguata (a discrezione del GM), puoi richiamare in essa gli spiriti che risiedevano nella Tua Arma, anche se quest'ultima è andata distrutta. Le eventuali proprietà magiche vengono trasferite assieme agli spiriti. Non puoi mai avere più di una singola *Arma Prescelta* o concessa dal *Vincolo della Lama*.",
  tags: [],
  prerequisites: [{ anyOf: ['guerriero.arma-prescelta', 'warlock.vincolo-della-lama'] }],
  replaces: [],
};

const parataEAffondo: Move = {
  id: 'guerriero.parata-e-affondo',
  name: 'Parata e Affondo',
  type: 'advanced_6_10',
  classId: 'guerriero',
  trigger: 'Quando effettui una *Parata*',
  description:
    "Aggiungi alla mossa *Parata* l'opzione «*Apri un varco nelle sue difese: ottieni +1 al tuo prossimo tiro di* taglia e spacca *contro di lui*». Inoltre, con 12+, scegli 3 opzioni dalla lista invece delle solite 2.",
  tags: [],
  prerequisites: ['guerriero.parata'],
  replaces: [],
};

const laSalvezzaNellAcciaio: Move = {
  id: 'guerriero.la-salvezza-nell-acciaio',
  name: "La Salvezza nell'Acciaio",
  type: 'advanced_6_10',
  classId: 'guerriero',
  trigger: "Quando impugni un'arma e puoi usarla in qualche modo per limitare i danni",
  description:
    "Ottieni +1 Armatura. L'utilizzo più ovvio è quello di ridurre l'impatto di un colpo in arrivo. Ma, ehi! Se ti spremi un po' le meningi potresti anche usare l'arma in modo più creativo. Pensa a piantare il tuo pugnale nel muro per frenare una caduta. Bello, no?",
  tags: [],
  prerequisites: ['guerriero.parata'],
  replaces: [],
};

const combattenteOpportunistico: Move = {
  id: 'guerriero.combattente-opportunistico',
  name: 'Combattente Opportunistico',
  type: 'advanced_6_10',
  classId: 'guerriero',
  trigger: 'Quando fai *taglia e spacca*',
  description:
    "Con 12+, anche se non concedi la risposta all'avversario, puoi comunque scegliere un'opzione dalla lista di *Tecniche Segrete di Combattimento*.",
  tags: [],
  prerequisites: ['guerriero.tecniche-segrete-di-combattimento'],
  replaces: [],
};

const spietato: Move = {
  id: 'guerriero.spietato',
  name: 'Spietato',
  type: 'advanced_6_10',
  classId: 'guerriero',
  trigger: 'Quando infliggi danni con un attacco',
  description: 'Infliggi +1d4 danni.',
  tags: [],
  prerequisites: ['guerriero.l-odore-del-sangue'],
  replaces: [],
};

const guerrieroSuperiore: Move = {
  id: 'guerriero.guerriero-superiore',
  name: 'Guerriero Superiore',
  type: 'advanced_6_10',
  classId: 'guerriero',
  trigger: 'Quando fai *taglia e spacca*',
  description:
    'Con 12+, oltre ai normali effetti, impressioni, demoralizzi o impaurisci profondamente il nemico. Il GM ti dirà come reagisce alla tua dimostrazione di superiorità.',
  tags: [],
  prerequisites: [],
  replaces: [],
};

const freddaDeterminazione: Move = {
  id: 'guerriero.fredda-determinazione',
  name: 'Fredda Determinazione',
  type: 'advanced_6_10',
  classId: 'guerriero',
  trigger:
    'Quando affronti una soverchiante orda di nemici molto più deboli di te (a discrezione del GM)',
  description:
    "Scegli cosa vuoi ottenere:\n\n- tenerli a bada e guadagnare tempo fino a che _____;\n- restare l'ultimo in piedi;\n- fendere l'orda per raggiungere _____;\n- impedirgli di raggiungere/ottenere _____;\n- spingerne un gran numero alla fuga o alla resa.\n\nPoi tira+**FOR**. Con 10+, raggiungi il tuo obiettivo, uccidendo o rendendo inoffensivi tutti i nemici necessari allo scopo. Con 7-9, lo stesso, ma il GM ti dirà a che prezzo. Con un 6-, sfoltisci l'orda, ma le cose si mettono parecchio male per te e/o per i tuoi compagni.",
  roll: {
    stat: 'forza',
    on10plus: { text: 'Raggiungi il tuo obiettivo, neutralizzi tutti i nemici necessari.' },
    on7to9: { text: 'Stesso esito ma a un prezzo (il GM lo dirà).' },
    on6minus: {
      text: "Sfoltisci l'orda ma le cose si mettono parecchio male per te o per i compagni.",
    },
  },
  tags: [],
  prerequisites: [],
  replaces: [],
};

const perfezioneInArmatura: Move = {
  id: 'guerriero.perfezione-in-armatura',
  name: 'Perfezione in Armatura',
  type: 'advanced_6_10',
  classId: 'guerriero',
  trigger:
    "Quando stai per subire danno e lasci che la tua armatura assorba il grosso dell'impatto",
  description:
    "Il danno viene annullato e prendi +1 al prossimo tiro contro l'aggressore, ma devi ridurre di 1 il valore di Armatura della tua corazza o del tuo scudo (a tua scelta). Il punteggio viene ridotto ogni volta che fai questa scelta. Se l'oggetto rimane con 0 Armatura, è distrutto.",
  tags: [],
  prerequisites: [],
  replaces: ['guerriero.maestria-in-armatura'],
};

const segnatoDallaBattaglia: Move = {
  id: 'guerriero.segnato-dalla-battaglia',
  name: 'Segnato dalla Battaglia',
  type: 'advanced_6_10',
  classId: 'guerriero',
  trigger: 'Quando fai il *fine sessione*',
  description:
    'Hai affrontato molte battaglie e imparato a convivere con le conseguenze. Puoi rimuovere una tua Debilitazione a scelta.',
  tags: [],
  prerequisites: [],
  replaces: [],
};

const estrazioneRapida: Move = {
  id: 'guerriero.estrazione-rapida',
  name: 'Estrazione Rapida',
  type: 'advanced_6_10',
  classId: 'guerriero',
  trigger: 'Quando inizia un combattimento e non sei colto di sorpresa',
  description:
    'I riflettori vengono sempre puntati su di te! Hai la prima parola e ottieni +1 al prossimo tiro che effettui.',
  tags: [],
  prerequisites: [],
  replaces: [],
};

const mercenarioDiLungoCorso: Move = {
  id: 'guerriero.mercenario-di-lungo-corso',
  name: 'Mercenario di Lungo Corso',
  type: 'advanced_6_10',
  classId: 'guerriero',
  trigger: 'Quando *parlamenti* con una persona potente o influente che sa delle tue gesta',
  description:
    'La tua fama di combattente ti precede. Se usi come leva la tua disponibilità a metterti al suo servizio, ottieni +1 al tiro. Con 12+, inoltre, ti viene proposta una ricompensa extra (oro, titoli, terre, a seconda della missione).',
  tags: [],
  prerequisites: ['guerriero.veterano'],
  replaces: [],
};

const malocchio: Move = {
  id: 'guerriero.malocchio',
  name: 'Malocchio',
  type: 'advanced_6_10',
  classId: 'guerriero',
  trigger: 'Quando entri in combattimento',
  description:
    "Tira+**CAR**. Con 10+, prendi 2. Con un 7-9, prendi 1. Spendi una presa per incrociare lo sguardo di un avversario, che s'immobilizza o esita finché continui a guardarlo fisso negli occhi. Non può muoversi o attaccare, ma si difenderà e risponderà agli attacchi come di consueto. Con un 6-, i nemici ti identificano come la minaccia più grande e faranno di tutto per renderti innocuo il prima possibile.",
  roll: {
    stat: 'carisma',
    on10plus: { text: 'Prendi 2 prese (incroci sguardo per immobilizzare).' },
    on7to9: { text: 'Prendi 1 presa.' },
    on6minus: { text: 'I nemici ti identificano come minaccia primaria.' },
  },
  tags: [],
  prerequisites: ['guerriero.vedere-rosso'],
  replaces: [],
};

const conGliOcchiDellaMorte: Move = {
  id: 'guerriero.con-gli-occhi-della-morte',
  name: 'Con gli Occhi della Morte',
  type: 'advanced_6_10',
  classId: 'guerriero',
  trigger: 'Quando inizi a combattere',
  description:
    'Tira+**SAG**. Con 10+, puoi indicare qualcuno che vivrà e qualcuno che morirà. Con un 7-9, invece, puoi indicare una sola creatura, che vivrà oppure che morirà. Indica dei PNG, non dei personaggi giocanti. Il GM farà in modo che la tua visione si avveri o, al momento giusto, ti darà una chiara opportunità perché tu stesso possa farla accadere. Con un 6-, vedi la tua morte e prendi un -1 continuato per tutta la durata dello scontro.',
  roll: {
    stat: 'saggezza',
    on10plus: { text: 'Indichi un PNG che vivrà e uno che morirà.' },
    on7to9: { text: 'Indichi un PNG che vivrà oppure morirà.' },
    on6minus: { text: 'Vedi la tua morte: -1 continuato per tutto lo scontro.' },
  },
  tags: [],
  prerequisites: [],
  replaces: [],
};

const fratelloDArmi: Move = {
  id: 'guerriero.fratello-d-armi',
  name: "Fratello d'Armi",
  type: 'advanced_6_10',
  classId: 'guerriero',
  trigger: 'Al level-up (livello 6-10), come scelta multiclasse ristretta',
  description:
    'Mossa *multiclasse*. Scegli una mossa non multiclasse del **Paladino** o del **Ranger**.',
  tags: ['multiclasse'],
  prerequisites: [],
  replaces: [],
  // FI-17 (D7): pool ristretto fisso a Paladino + Ranger.
  multiclass: {
    picks: { kind: 'fixed-classes', classes: ['paladino', 'ranger'] },
  },
};

export const guerrieroAdvanced6to10Moves: readonly Move[] = [
  fabbro,
  parataEAffondo,
  laSalvezzaNellAcciaio,
  combattenteOpportunistico,
  spietato,
  guerrieroSuperiore,
  freddaDeterminazione,
  perfezioneInArmatura,
  segnatoDallaBattaglia,
  estrazioneRapida,
  mercenarioDiLungoCorso,
  malocchio,
  conGliOcchiDellaMorte,
  fratelloDArmi,
] as const;
